import { api } from '@fno/service/global.js'

export const postPublicFile = async ({ file }) => {

    const postResponse = await api.postImage(`/v2/publicMedia`, file)

    // return the data in the s3File fragment structure
    return {
        mimeType: postResponse.metadata.mimetype,
        byteLength: file.size,
        key: postResponse.key,
        bucket: postResponse.bucket,
        filename: postResponse.metadata.filename,
        url: `https://${postResponse.bucket}/${postResponse.key}` // not in the s3File type definition, but used in older `image` fragment type
    }
}

export const postPrivateFile = async ({ schoolId, file }) => {

    const data = {
        data: {
            type: 'FILE',
            attributes: {
                title: file.name,
                category: 'upload',
                file: {
                    filename: file.name,
                    mimeType: file.type,
                    byteLength: file.size
                }
            }
        }
    }

    const postResponse = await api.post(`/v2/schools/${schoolId}/files`, data)
        .then(response => response.data)

    const s3Response = await api.put(`/awsProxy/${postResponse.meta.preSignedUrl}`, { data: file.data })
        .then(response => response.data)

    return s3Response
}

